require('./hiringProductInformationRiskLevel.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ helpers
const { formatText } = require('core/i18n').i18n;

class HiringProductInformationRiskLevel extends React.Component {

    render() {
        const { immRiskLevel, immRiskLiquidityAlert } = this.props;

        let liquidityAlert;
        if (!!immRiskLiquidityAlert.size) {
            const field_text = immRiskLiquidityAlert.get('field_text');
            const field_icon = immRiskLiquidityAlert.get('field_icon');
            const disclaimer = formatText('hireInformationComponent-liquidityAlert');

            liquidityAlert= (
                <div className="hiring-product-information-risk-level__alert-block">
                    <div className="hiring-product-information-risk-level__disclaimer-alert">
                        {disclaimer}
                    </div>
                    <div className="hiring-product-information-risk-level__alert-left">
                        <i className={field_icon}></i>
                        <i className={field_icon}></i>
                    </div>
                    <div className="hiring-product-information-risk-level__alert-right">
                        {field_text}
                    </div>
                </div>
            )
        }
        return (
            <div className="hiring-product-information-risk-level__risk">
                <div className="hiring-product-information-risk-level__risk-block">
                    <div className="hiring-product-information-risk-level__risk-value">
                        <span className="hiring-product-information-risk-level__risk-value--light">{immRiskLevel.get('field_risk_level_bde')}</span>
                        <span className="hiring-product-information-risk-level__risk-value--dark">/6</span>
                    </div>
                    <div className="hiring-product-information-risk-level__risk-explanation">{immRiskLevel.get('field_text')}</div>
                </div>
                <div className="hiring-product-information-risk-level__risk-disclaimer">
                    <div className="hiring-product-information-risk-level__risk-explanation">{immRiskLevel.get('field_description')}</div>
                </div>
                {liquidityAlert}
            </div>
        );
    }
}

HiringProductInformationRiskLevel.propTypes = {
    immRiskLevel: PropTypes.object,
    immRiskLiquidityAlert: PropTypes.object,
};

module.exports = HiringProductInformationRiskLevel;